import { useSetAtom } from "jotai";
import Head from "next/head";
import { type ReactElement } from "react";
import BreadCrumbs from "~/components/breadcrumbs/BreadCrumbs";
import { FullWidthContainer } from "~/components/layout/Container";
import Layout from "~/components/layout/Layout";
import PublicNPCsDashboard from "~/components/npc/PublicNPCsDashboard";
import { breadcrumbsAtom } from "~/lib/atom";

const PublicNPCsPage = () => {
  const setBreadcrumbs = useSetAtom(breadcrumbsAtom);
  setBreadcrumbs([
    {
      name: "Explore AI NPCs",
      href: "/explore-npcs",
      current: true,
    },
  ]);

  return (
    <>
      <Head>
        <title>RFOX VALT | NPC</title>
      </Head>
      <FullWidthContainer>
        <BreadCrumbs />
        <PublicNPCsDashboard />
      </FullWidthContainer>
    </>
  );
};

PublicNPCsPage.getLayout = function getLayout(page: ReactElement) {
  return <Layout publicAccess={true}>{page}</Layout>;
};

export default PublicNPCsPage;
